// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"ProductPage-module__pageContainer___1T9Lz","modal__productName":"ProductPage-module__modal__productName___3a88p","modal__productDescription":"ProductPage-module__modal__productDescription___1jBXp"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ProductPage/ProductPage.module.css
// module id = 642
// module chunks = 0